import React, { FC, useCallback } from 'react';

interface Props {
  quote: { id: number; quantity?: number; productReference?: any; delivered?: boolean; waitingSupplier?: boolean };
  onQuoteChange: (quoteId: number, value: string) => void;
}

const orderStates = ['Non commandé', 'En cours de commande', 'Livré'];

const QuoteVirtual: FC<Props> = ({ quote, onQuoteChange }) => {
  const handleQuoteChange = useCallback(
    (e) => {
      onQuoteChange(quote.id, e.target.value);
    },
    [quote, onQuoteChange]
  );

  return (
    <li
      className={
        'list-group-item entity-row spaced ' +
        (quote.waitingSupplier ? 'marked-positive ' : quote.delivered ? '' : 'marked-negative ')
      }
    >
      <span>{quote.productReference.wording}</span>
      <span className='icon icon-text-document'>{quote.quantity}</span>
      <select
        value={quote.waitingSupplier ? orderStates[1] : quote.delivered ? orderStates[2] : orderStates[0]}
        onChange={handleQuoteChange}
        className='form-control'
      >
        {orderStates.map((state, i) => (
          <option key={i} value={state}>
            {state}
          </option>
        ))}
      </select>
    </li>
  );
};

export default QuoteVirtual;
